import { Combo } from 'types/combo';
import Select, { createFilter } from 'react-select';
import { useMaterialUIController } from 'context';
import { useTranslation } from 'react-i18next';

type MultiSelectStandaloneProps = {
    options: Combo[];
    value?: (string | number)[];
    onChange: (values: (string | number)[]) => void;
    placeholder?: string;
    disabled?: boolean;
    autoFocus?: boolean;
};

const MultiSelectStandalone = ({
    options,
    value,
    onChange,
    placeholder,
    disabled,
    autoFocus,
}: MultiSelectStandaloneProps) => {
    const { t } = useTranslation();
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;

    return (
        <Select
            isMulti
            autoFocus={autoFocus}
            menuPortalTarget={document.body}
            menuPosition="fixed"
            options={options}
            filterOption={createFilter({ stringify: (option) => option.label })}
            isDisabled={disabled}
            value={options.filter((option: Combo) =>
                Array.isArray(value) ? value.includes(option.value) : false
            )}
            onChange={(options) => {
                const values = options ? options.map((o: Combo) => o.value) : [];
                onChange(values);
            }}
            placeholder={placeholder || t('general.selecione')}
            styles={{
                control: (base) => ({
                    ...base,
                    background: 'transparent',
                    border: darkMode ? '1px solid #405568' : 'lightgray solid 1px',
                    borderRadius: '5px',
                    minWidth: '155px',
                    minHeight: '43px',
                    color: darkMode ? '#ffffff' : '#000000',
                }),
                placeholder: (base) => ({
                    ...base,
                    fontSize: '14px',
                    color: darkMode ? '#b8c5d1' : '#6c757d',
                }),
                menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                }),
                menu: (base) => ({
                    ...base,
                    fontSize: '14px',
                    backgroundColor: darkMode ? '#1b2536' : '#FFFFFF',
                    color: darkMode ? '#ffffff' : '#000',
                    zIndex: 9999,
                }),
                option: (base, state) => ({
                    ...base,
                    backgroundColor: state.isFocused
                        ? darkMode
                            ? '#26324a'
                            : '#e9ecef'
                        : darkMode
                        ? '#1b2536'
                        : '#FFFFFF',
                    color: darkMode ? '#ffffff' : '#000000',
                    ':hover': {
                        backgroundColor: darkMode ? '#26324a' : '#e9ecef',
                    },
                }),
                input: (base) => ({
                    ...base,
                    fontSize: '14px',
                    color: darkMode ? '#ffffff' : '#000000',
                }),
                multiValue: (base) => ({
                    ...base,
                    backgroundColor: darkMode ? '#26324a' : '#e9ecef',
                }),
                multiValueLabel: (base) => ({
                    ...base,
                    color: darkMode ? '#ffffff' : '#000000',
                }),
            }}
        />
    );
};

export default MultiSelectStandalone;
